import _ from 'lodash'
import moment from 'moment'

import LatLng from './LatLng'

import SlidingMaker from 'marker-animate-unobtrusive'
SlidingMaker.initializeGlobally()

import MarkerWithLabel from 'marker-with-label'
const Marker = MarkerWithLabel(google.maps)

import CustomMarker from './CustomMarker'

const EventEmitter = require( 'events' )

export default class Trackable extends EventEmitter {
    constructor(options = {}){
        super()
        const defaultOptions = {
            type: 'device',
            name: "Dispositivo",
            color: "#429BF5",
            avatarUrl: require('../../assets/imgs/default-avatar.png'),
            trackLimitInMinutes: 5 // time in minutes
        }
        this._marker = new CustomMarker()
        this._track = new google.maps.Polyline({
            path: [],
            geodesic: false,
            visible: true,
            icons: [{
                icon: {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    strokeOpacity: 1,
                    scale: 2,
                    rotation: 180
                },
                repeat: '50px',
                offset: "50px"
            }],
            strokeColor: "#61AFEF",
            strokeOpacity: .7,
            strokeWeight: 6
        })
        this._options = _.assign(defaultOptions, options)
        this._data = null
        this._map = null

        this._animationQueue = []
        this._lastReceivedPosition = null
        this._isAnimating = false
    }
    async setData(data){
        if(!this._data){
            this._data = data
        }
        else {
           this._data =  _.assign(this._data,data)
        }
        if(this._marker){
            await this._marker.setLabel(this._data.name,this._options.color)
            this._track.setOptions({
                strokeColor: this._data.color
            })
        }
    }
    setMap(map){
        this._map = map
        this._track.setMap(this._map)
        if(this._data){
            this.setVisible(this._data.available)
        }
    }
    async setVisible(value){
        if(this._marker)
        await this._marker.setVisible(!!value)
        if(this._track)
        await this._track.setVisible(!!value)
    }
    addLocations(locationArray, cb = (latLng) => {}){
        if(!_.isArray(locationArray)){
            locationArray = [locationArray]
        }
        locationArray.forEach((location) => {
            location = this._getLocationLatLng(location)
            this._animationQueue.push(location)
        })
        this._animationQueue = _.sortBy(this._animationQueue,(animationQueueItem) => {
            return moment(animationQueueItem.getData().dateGenerated)
        })
        this._lastReceivedPosition = _.last(this._animationQueue)
        if(this._isAnimating) return
        this.animate(cb)
    }
    setColor(color) {
        _.assign(this._options,{
            color
        })
        if(this._marker){
            this._marker.setColor(color) 
        }
        if(this._track){
            this._track.setOptions({
                strokeColor: color
            })
        }
    }
    setLabel(label,color="#000000") {
        _.assign(this._data,{
            name: label
        })
        _.assign(this._options,{
            name: label
        })
        if(!this._marker) return
        this._marker.setLabel(label,color) 
    }
    async setAvatar(avatarUrl) {
        _.assign(this._options,{
            avatarUrl
        })
        if(!this._marker) return
        await this._marker.setAvatar(avatarUrl) 
    }
    animate(cb){
        if(!this._animationQueue.length){
            if(!this._animationQueue.length && this._lastReceivedPosition){
                this._marker.setPosition(this._lastReceivedPosition)
            }
            this._isAnimating = false
            this.emit('location',this._marker.getPosition())
            return cb(this._marker.getPosition())
        }
        const latLng = _.first(this._animationQueue)
        this._animationQueue.splice(0,1)

        const currentTime = moment()
        const isOutDated = moment(latLng.getData().dateGenerated).add(this._options.trackLimitInMinutes, 'minutes').isBefore(currentTime)

        // set marker position
        if(!this._marker.getMap()){
            this._marker.setMap(this._map)
            this._marker.setPosition(latLng)
            const avatar = (this._options && this._options.avatarUrl) ? this._options.avatarUrl : require('../../assets/imgs/default-avatar.png')
            this._marker.setColor(this._options.color)
            this._marker.setAvatar(avatar)
            this._marker.setLabel(this._data.name,this._options.color)
            
            // set path
            const path = this._track.getPath()
            
            path.insertAt(0,latLng)
            setTimeout(() => {
                if(!!this._data.visible) 
                    this.setVisible(this._data.visible)
                this.animate(cb)
            }, 500)
        }
        else {
            if(isOutDated){
                return this.animate(cb)
            }
            this._marker.setPosition(latLng)
            setTimeout(() => {
                // set path
                const path = this._track.getPath()
                path.insertAt(0,latLng)
                if(!!this._data.available) this.setVisible(this._data.available)
                this.animate(cb)
            }, 500)
        }
    }
    getData(){
        return this._data
    }
    getMarker(){
        return this._marker
    }
    getTrack(){
        return this._track
    }
    update(){
        // remove timedout locations from map
        if(!this._track.getMap() || this._isAnimating) return
        const currentTime = moment()
        const trackPath = this._track.getPath()
        if(trackPath.length < 2) return
        trackPath.forEach((latLng, index) => {
            if(!latLng) return
            const location = latLng.getData()
            if(index === 0) return
            if(moment(location.dateGenerated).add(this._options.trackLimitInMinutes, 'minutes').isBefore(currentTime)){
                trackPath.removeAt(index)
            }
        })
    }
    _getLocationLatLng(location){
        const latLng = new LatLng({
            lat: location.lat,
            lng: location.lng
        })
        latLng.setData(location)
        return latLng
    }
}